import { gql, QueryHookOptions } from '@apollo/client';
import { GraphQLResponsePaginationInfo } from 'modules/graphql';
import {
  DEFAULT_PAGINATION as pagination,
  DEFAULT_SORT_BY as sortBy,
  DEFAULT_SORT_DIRECTION as sortDirection,
} from 'modules/quickActionsMenu/constants';
import { GraphQLSnippet } from 'modules/snippets/types';
import { useGraphql } from 'utils/hooks/useGraphql';
import { GraphQLVariables } from '../types';

export const fetchQuickActionsSnippets = gql`
  query fetchQuickActionsSnippets($pagination: Pagination, $search: String, $sort: Sort) {
    fetchSnippets(pagination: $pagination, search: $search, sort: $sort) {
      paginationInfo {
        count
        offset
        limit
        page
      }
      results {
        id
        name
      }
    }
  }
`;

type QuerySnippetsResponse = {
  fetchSnippets: {
    paginationInfo: GraphQLResponsePaginationInfo;
    results: Pick<GraphQLSnippet, 'id' | 'name'>[];
  };
};

export const useQuerySnippets = (
  search: string,
  options?: QueryHookOptions<QuerySnippetsResponse, GraphQLVariables>,
) =>
  useGraphql<QuerySnippetsResponse>(fetchQuickActionsSnippets, {
    ...options,
    notifyOnNetworkStatusChange: true,
    variables: {
      search,
      sort: { sortBy, sortDirection },
      pagination,
    },
  });
